// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MapComponent from './components/MapComponent';
import MissionView from './pages/MissionView'; // make sure this path is correct

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Pilot application: available at /pilot/ */}
        <Route path="/" element={<MapComponent />} />
        <Route path="/pilot" element={<MapComponent />} />
        <Route path="/pilot/" element={<MapComponent />} />

        {/* Shared mission view — preserve existing URLs */}
        <Route path="/m/:id" element={<MissionView />} />
      </Routes>
    </Router>
  );
};

export default App;
